'use strict';

import _ from 'lodash';
import React from 'react';
import Partner from '../common/partner';
import Custom from '../common/custom';
import Sponsor from '../common/sponsor';
import Analytics from '../common/analytics';

class Custom_Content extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    let custom_content = this.props.conference.current.custom_content ?
      this.props.conference.current.custom_content[this.props.params.custom_content_id] :
      null;

    return <div className="sponsors">
      <section className="section">
        <div className="opportunities wrap-two clearfix">
          {!custom_content ? null : <Custom key={custom_content._id} custom={custom_content} showPhoto={true} showBio={true} {...this.props} />}
        </div>
      </section>
      <Analytics view="custom_content" {...this.props} />
    </div>
  }
}

export default Custom_Content;
